import { render, staticRenderFns } from "./NoticeBoardWidget.vue?vue&type=template&id=503fb579&scoped=true&"
import script from "./NoticeBoardWidget.vue?vue&type=script&lang=js&"
export * from "./NoticeBoardWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503fb579",
  null
  
)

export default component.exports